import { useState } from "react";
import { FaEye, FaEyeSlash, FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ConnectModal from "./ConnectModal";
import apis from "../services";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector } from "react-redux";
import { setUser } from "../redux/userSlice";
import { useDispatch } from "react-redux";

const SetPassword = ({ onClose }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isPasswordSet, setIsPasswordSet] = useState(true);
  const { data } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const updateUser = async () => {
    await axios.post(
      `https://looknatest.com/wallet/api/user/update-wallet-status`,
      {
        userId: data?._id,
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    await axios
      .post(
        `https://looknatest.com/wallet/wallet/setPassword`,
        {
          email: data?.email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setIsPasswordSet(false);
          updateUser();
        }
      })
      .catch((err) => {
        toast.error("Already set password");
      });
  };

  return (
    <>
      {isPasswordSet ? (
        <div className="connect-modal-overlay">
          <div className="connect-modal">
            <div className="connect-header">
              <button className="connect-back-btn" onClick={onClose}>
                <FaArrowLeft />
              </button>
              <h2 className="connect-title">Account</h2>
            </div>
            <form className="connect-content" onSubmit={handleSubmit}>
              <label className="connect-label">Set Password</label>
              <div className="connect-password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  className="connect-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  className="connect-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <button type="submit" className="connect-button">
                Connect
              </button>
            </form>
          </div>
        </div>
      ) : (
        <ConnectModal onClose={onClose} />
      )}
    </>
  );
};

export default SetPassword;
